/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/information_bubble_medium'
export default icon
